import { render } from "./DesignatedLeadsView.vue?vue&type=template&id=565d4589"
import script from "./DesignatedLeadsView.vue?vue&type=script&lang=js"
export * from "./DesignatedLeadsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__